import React from 'react';
import { useUsers } from './hooks/useUsers';
import { UsersTable } from './components/UsersTable';
import { Card } from '@/components/ui';

// Users Icon
const UsersIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={className || 'w-6 h-6'}
  >
    <path d="M4.5 6.375a4.125 4.125 0 118.25 0 4.125 4.125 0 01-8.25 0zM14.25 8.625a3.375 3.375 0 116.75 0 3.375 3.375 0 01-6.75 0zM1.5 19.125a7.125 7.125 0 0114.25 0v.003l-.001.119a.75.75 0 01-.363.63 13.067 13.067 0 01-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 01-.364-.63l-.001-.122zM17.25 19.128l-.001.144a2.25 2.25 0 01-.233.96 10.088 10.088 0 005.06-1.01.75.75 0 00.42-.643 4.875 4.875 0 00-6.957-4.611 8.586 8.586 0 011.71 5.157v.003z" />
  </svg>
);

export const UsersSection: React.FC = () => {
  const { users, organizations, loading, error, actionLoading, updateUser } =
    useUsers();

  return (
    <Card padding="lg">
      <div className="flex items-center mb-4">
        <UsersIcon className="w-6 h-6 mr-3 text-primary-600" />
        <h2 className="text-xl font-semibold text-secondary-900">
          User Management
        </h2>
      </div>

      <p className="text-secondary-600 mb-4">
        Manage user roles and organization assignments. Click the edit icon to
        modify a user.
      </p>

      <UsersTable
        users={users}
        organizations={organizations}
        loading={loading}
        error={error}
        actionLoading={actionLoading}
        onUpdateUser={updateUser}
      />
    </Card>
  );
};

export default UsersSection;
